import React from "react"
import gql from "graphql-tag"

import Query from "../../query/Query"

export const insGlobal = gql`
  query InsGlobal {
     insGlobal @client {
        tenant
        cycleId
        interestId
     }
  }
`

const GetInsGlobal = ({children, ...props}) => {
  return (
    <Query {...props} query={insGlobal}>
      {({data: {insGlobal: data}, ...apolloState}) => {
        return children({...data, ...apolloState})
      }}
    </Query>
  )
}


export default GetInsGlobal
